// Classes the assistant's chat repeats: a framed card, and the line between two rows of a list.
export const cardClassName =
    "rounded-2xl border border-assistant-cardBorder bg-white";
export const rowDividerClassName =
    "border-b border-assistant-cardBorder last:border-b-0";
// The small panels under the input (the gauge, the memory), in Anthropic's colours: ivory, ink, warm greys.
export const panelClasses = {
    surface: "bg-gauge-surface",
    border: "border-gauge-line",
    track: "bg-gauge-line",
    ink: "text-gauge-ink",
    muted: "text-gauge-muted",
    hover: "hover:bg-gauge-hover",
};
// The action a card offers first (create, confirm): MailVista's purple, white text.
export const primaryButtonClassName =
    "h-9 rounded-full border-0 bg-gradient-to-r from-assistant-send to-assistant-ink px-4 text-sm font-semibold text-white hover:text-white hover:brightness-110 disabled:opacity-60";
export const assistantIconButtonClassName =
    "h-8 w-8 rounded-lg p-0 text-assistant-muted backdrop-blur-none hover:bg-white/70 hover:text-primary-darkest [&_svg]:size-5";
export const secondaryButtonClassName =
    "h-9 rounded-full border border-assistant-outline bg-white px-4 text-sm font-semibold text-primary-darkest hover:bg-assistant-chip";
export const pillButtonClassName =
    "inline-flex h-11 items-center justify-center gap-2 rounded-full border border-assistant-outline bg-white px-5 text-base font-semibold text-primary-darkest transition-colors hover:bg-assistant-chip disabled:cursor-default disabled:opacity-60 [&_svg]:size-4";
